import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ConsentData, Field } from '../../shared/interfaces/hubspot-form-data';
import { FormUtilsService } from '../../shared/services/form-utils.service';
import { FormsService } from '../../shared/services/forms.service';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

@Component({
    selector: 'da-form-field-legal-consent',
    templateUrl: './legal-consent.component.html',
    styleUrls: ['./legal-consent.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LegalConsentComponent implements OnInit, OnDestroy {
    @Input() consentData: ConsentData;
    @Input() group: UntypedFormGroup;
    @Input() formId: string;
    public field: Field;
    private _$isSubmitting: BehaviorSubject<boolean> = new BehaviorSubject(false);
    private _currentConsentBoxNames: Array<string> = [];
    private _serviceSubscription: Subscription;

    constructor(private _formUtils: FormUtilsService, private _FormsService: FormsService, protected _ref: ChangeDetectorRef) {}

    ngOnChanges(changes: SimpleChanges) {
        const _groupChanges = changes.group;
        const _consentDataChanges = changes.consentData;
        if (_consentDataChanges && _groupChanges) {
            this._setLegalConsensFields();
        }
    }
    public get isSubmitting$(): Observable<boolean> {
        return this._$isSubmitting.asObservable();
    }

    ngOnInit() {
        this._setLegalConsensFields();
    }

    ngOnDestroy() {
        this._serviceSubscription.unsubscribe();
    }
    public getErrorTranslation(error: any): string {
        if (!this.field) {
            return '';
        }
        return this._formUtils.getErrorTranslation(error, this.group, this.field);
    }

    private _setFormFieldsForConsent() {
        for (const checkbox in this.consentData.communicationConsentCheckboxes) {
            const _checkbox = this.consentData.communicationConsentCheckboxes[checkbox];
            const _fieldName = 'LEGAL_CONSENT.subscription_type_' + _checkbox.communicationTypeId;
            this._currentConsentBoxNames.push(_fieldName);
            this.group.controls[_fieldName] = new UntypedFormControl(false);
            if (_checkbox.required) {
                this.group.controls[_fieldName].setValidators(Validators.requiredTrue);
            }
        }

        if (this.consentData.processingConsentType === 'REQUIRED_CHECKBOX') {
            const _fieldNameProcessing = 'LEGAL_CONSENT.processing';
            this._currentConsentBoxNames.push(_fieldNameProcessing);
            this.group.controls[_fieldNameProcessing] = new UntypedFormControl();
            this.group.controls[_fieldNameProcessing].setValidators(Validators.requiredTrue);
        }
    }

    onCheckboxChange(checked: any, fieldName: any) {
        this.group.controls[fieldName].setValue(checked);
        this.group.updateValueAndValidity();
        this._ref.detectChanges();
    }

    private _setLegalConsensFields() {
        const _hasFormFields = !this.consentData.isLegitimateInterest;
        if (_hasFormFields) {
            this._setFormFieldsForConsent();
            this._serviceSubscription = this._FormsService
                .submitting$(this.formId)
                .pipe(distinctUntilChanged())
                .subscribe((isSubmitting) => {
                    if (isSubmitting) {
                        for (const name of this._currentConsentBoxNames) {
                            const ctrl = this.group.controls[name];
                            ctrl.markAsTouched();
                        }
                        this._ref.detectChanges();
                        this._$isSubmitting.next(isSubmitting);
                    }
                });
        }
    }
}
